import React from 'react'
import { PeriodSummary } from '../../api/period-summaries'
import { Column } from 'react-table'
import { ResourceLinkCell } from '../../components/table/cells'
import { Element } from 'react-bulma-components'
import Table from '../../components/table'
import { localDate } from '../../utils/date'
import useStore from '../../store'
import { SessionSlice } from '../../store/session'
import useFilters from '../../hooks/filters'
import PreBillingsFilters from '../../components/pre-bilings/filters'
import { FiltersResourcesEnum } from '../../store/filters'
import ListPageLayout from '../../components/layout/list-page-layout'
import { usePeriodSummariesQuery } from '../../queries/period-summaries'

const PreBillingsList: React.FC = () => {
  const currentUserRole = useStore(({ session }) => session.currentUserRole)
  const { filters } = useFilters(FiltersResourcesEnum.preBillings)
  const tableColumns = useListTableColumns(currentUserRole)

  const periodSummariesQuery = usePeriodSummariesQuery({
    'createdAt>': filters.start || null,
    'createdAt<': filters.end || null,
    contractModel: 'threeParties',
    invoiceRef: filters.invoiceRef,
    interimAgency: filters.interimAgency,
    sort: '-createdAt',
  })

  const preBillings = periodSummariesQuery.data || []
  const totalCost = preBillings.reduce<number>(
    (total, preBilling) => (total += preBilling.data.costs.total),
    0,
  )

  const action = (
    <Element textSize={5}>
      <Element renderAs="span">Total : </Element>
      <Element renderAs="strong">&nbsp;{totalCost.toFixed(2)} €</Element>
    </Element>
  )

  return (
    <ListPageLayout
      title="Liste des Pré-Facturations"
      subtitle="Un Employeur génère une Pré-facturation via son Récapitulatif"
      action={action}
      filters={<PreBillingsFilters />}
    >
      <Table
        columns={tableColumns}
        data={preBillings}
        noDataMessage="Aucune pré-facturation à afficher"
      />
    </ListPageLayout>
  )
}

export default PreBillingsList

const useListTableColumns = (
  currentUserRole: SessionSlice['currentUserRole'],
): Column<PeriodSummary>[] => {
  return React.useMemo(
    () => [
      {
        Header: '#',
        accessor: 'identifier',
        Cell: data => (
          <ResourceLinkCell
            resource={data.row.original}
            path="/pre-billings/"
            label={data.row.original.identifier}
          />
        ),
      },
      {
        Header: currentUserRole === 'interimAgencyMember' ? 'Employeur' : 'Agence',
        accessor: currentUserRole === 'interimAgencyMember' ? 'employer' : 'interimAgency',
        Cell: (data: any) =>
          currentUserRole === 'interimAgencyMember'
            ? data.row.original.employer.name
            : data.row.original.interimAgency.name,
      },
      {
        Header: 'N° Facture',
        //@ts-ignore
        accessor: 'invoiceRef',
      },
      {
        Header: 'Semaine',
        //@ts-ignore
        accessor: 'period.week',
      },
      {
        Header: 'Créé le',
        accessor: 'createdAt',
        Cell: data => localDate(data.row.original.createdAt),
      },
      {
        Header: 'Coût',
        //@ts-ignore
        accessor: 'data.costs.total',
        //@ts-ignore
        Cell: data => `${data.row.original.data.costs.total} €`,
      },
    ],
    [],
  )
}
